import { render, staticRenderFns } from "./split.vue?vue&type=template&id=0600d8e0"
import script from "./split.vue?vue&type=script&lang=js"
export * from "./split.vue?vue&type=script&lang=js"
import style0 from "./split.vue?vue&type=style&index=0&id=0600d8e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports